// AUTO-GENERATED — do not edit. Run npm run gen:trees to regenerate.
import type { DecisionTrees } from '../models/decision-tree.model';

export const DECISION_TREES: DecisionTrees = {
  "version": "1.0.0",
  "trades": {
    "heizung": {
      "id": "heizung",
      "name": "Heizung",
      "icon": "sun",
      "rootNodeId": "heizung_problem",
      "nodes": {
        "heizung_problem": {
          "id": "heizung_problem",
          "type": "single_select",
          "question": "Was ist das Problem mit der Heizung?",
          "options": [
            {
              "label": "Heizung geht gar nicht",
              "value": "kompletter_ausfall",
              "next": "heizung_art"
            },
            {
              "label": "Heizung wird nicht richtig warm",
              "value": "wird_nicht_warm",
              "next": "heizung_art"
            },
            {
              "label": "Heizkörper tropft / Wasser läuft aus",
              "value": "leck",
              "next": "heizung_wo"
            },
            {
              "label": "Macht Geräusche (Klopfen, Pfeifen, Gluckern)",
              "value": "geraeusche",
              "next": "heizung_wo"
            },
            {
              "label": "Wartung / Inspektion",
              "value": "wartung",
              "next": "heizung_art"
            },
            {
              "label": "Neuinstallation / Austausch",
              "value": "neuinstallation",
              "next": "heizung_art"
            },
            {
              "label": "Etwas anderes",
              "value": "sonstiges",
              "next": "heizung_art"
            }
          ]
        },
        "heizung_art": {
          "id": "heizung_art",
          "type": "single_select",
          "question": "Was für eine Heizung haben Sie?",
          "options": [
            {
              "label": "Gasheizung",
              "value": "gas",
              "next": "heizung_wo"
            },
            {
              "label": "Ölheizung",
              "value": "oel",
              "next": "heizung_wo"
            },
            {
              "label": "Wärmepumpe",
              "value": "waermepumpe",
              "next": "heizung_wo"
            },
            {
              "label": "Fernwärme",
              "value": "fernwaerme",
              "next": "heizung_wo"
            },
            {
              "label": "Stromheizung / Nachtspeicher",
              "value": "strom",
              "next": "heizung_wo"
            },
            {
              "label": "Weiß ich nicht",
              "value": "unbekannt",
              "next": "heizung_wo"
            }
          ]
        },
        "heizung_wo": {
          "id": "heizung_wo",
          "type": "single_select",
          "question": "Wo tritt das Problem auf?",
          "options": [
            {
              "label": "An einem einzelnen Heizkörper",
              "value": "einzeln",
              "next": "duration_ref"
            },
            {
              "label": "In einem Raum",
              "value": "ein_raum",
              "next": "duration_ref"
            },
            {
              "label": "In mehreren Räumen",
              "value": "mehrere_raeume",
              "next": "duration_ref"
            },
            {
              "label": "Im ganzen Haus / der ganzen Wohnung",
              "value": "komplett",
              "next": "duration_ref"
            },
            {
              "label": "An der Heizungsanlage selbst (Keller / Therme)",
              "value": "anlage",
              "next": "duration_ref"
            }
          ]
        },
        "duration_ref": {
          "id": "duration",
          "type": "single_select",
          "question": "Seit wann besteht das Problem?",
          "next": "urgency_ref",
          "options": [
            {
              "label": "Gerade eben aufgetreten",
              "value": "gerade"
            },
            {
              "label": "Heute",
              "value": "heute"
            },
            {
              "label": "Seit ein paar Tagen",
              "value": "tage"
            },
            {
              "label": "Seit über einer Woche",
              "value": "woche_plus"
            },
            {
              "label": "Schon länger / kommt immer wieder",
              "value": "wiederkehrend"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "elektriker": {
      "id": "elektriker",
      "name": "Elektriker",
      "icon": "lightning",
      "rootNodeId": "elektriker_problem",
      "nodes": {
        "elektriker_problem": {
          "id": "elektriker_problem",
          "type": "single_select",
          "question": "Was ist das Problem?",
          "options": [
            {
              "label": "Strom komplett ausgefallen",
              "value": "totalausfall",
              "next": "elektriker_wo"
            },
            {
              "label": "Sicherung fliegt ständig raus",
              "value": "sicherung",
              "next": "elektriker_wo"
            },
            {
              "label": "Steckdose oder Schalter defekt",
              "value": "steckdose",
              "next": "elektriker_wo"
            },
            {
              "label": "Beleuchtung / Lampe defekt",
              "value": "beleuchtung",
              "next": "elektriker_wo"
            },
            {
              "label": "Neuinstallation / Verlegung",
              "value": "neuinstallation",
              "next": "elektriker_wo"
            },
            {
              "label": "Wallbox / E-Auto-Ladestation",
              "value": "wallbox",
              "next": "elektriker_wallbox_typ"
            },
            {
              "label": "Smart Home / Netzwerk",
              "value": "smarthome",
              "next": "elektriker_wo"
            },
            {
              "label": "E-Check / Prüfung",
              "value": "e_check",
              "next": "elektriker_wo"
            }
          ]
        },
        "elektriker_wallbox_typ": {
          "id": "elektriker_wallbox_typ",
          "type": "single_select",
          "question": "Was soll passieren?",
          "options": [
            {
              "label": "Neü Wallbox installieren",
              "value": "neuinstallation",
              "next": "urgency_ref"
            },
            {
              "label": "Bestehende Wallbox reparieren",
              "value": "reparatur",
              "next": "urgency_ref"
            },
            {
              "label": "Beratung / Angebot",
              "value": "beratung",
              "next": "urgency_ref"
            }
          ]
        },
        "elektriker_wo": {
          "id": "elektriker_wo",
          "type": "single_select",
          "question": "Wo tritt das Problem auf?",
          "options": [
            {
              "label": "Eine einzelne Stelle (z.B. eine Steckdose)",
              "value": "einzeln",
              "next": "duration_ref"
            },
            {
              "label": "Ein Raum",
              "value": "ein_raum",
              "next": "duration_ref"
            },
            {
              "label": "Mehrere Räume",
              "value": "mehrere_raeume",
              "next": "duration_ref"
            },
            {
              "label": "Ganzes Haus / komplette Wohnung",
              "value": "komplett",
              "next": "duration_ref"
            },
            {
              "label": "Außenbereich / Garten",
              "value": "aussen",
              "next": "duration_ref"
            }
          ]
        },
        "duration_ref": {
          "id": "duration",
          "type": "single_select",
          "question": "Seit wann besteht das Problem?",
          "next": "urgency_ref",
          "options": [
            {
              "label": "Gerade eben aufgetreten",
              "value": "gerade"
            },
            {
              "label": "Heute",
              "value": "heute"
            },
            {
              "label": "Seit ein paar Tagen",
              "value": "tage"
            },
            {
              "label": "Seit über einer Woche",
              "value": "woche_plus"
            },
            {
              "label": "Schon länger / kommt immer wieder",
              "value": "wiederkehrend"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "sanitaer": {
      "id": "sanitaer",
      "name": "Sanitär",
      "icon": "wrench",
      "rootNodeId": "sanitaer_problem",
      "nodes": {
        "sanitaer_problem": {
          "id": "sanitaer_problem",
          "type": "single_select",
          "question": "Worum geht es?",
          "options": [
            {
              "label": "Verstopfung (Abfluss, WC)",
              "value": "verstopfung",
              "next": "sanitaer_wo"
            },
            {
              "label": "Wasserschaden / Leck",
              "value": "leck",
              "next": "sanitaer_leck_staerke"
            },
            {
              "label": "Tropfender Wasserhahn",
              "value": "tropfender_hahn",
              "next": "sanitaer_wo"
            },
            {
              "label": "WC defekt (Spülung, undicht)",
              "value": "wc",
              "next": "duration_ref"
            },
            {
              "label": "Kein oder zu wenig Wasser",
              "value": "kein_wasser",
              "next": "sanitaer_wo"
            },
            {
              "label": "Boiler / kein Warmwasser",
              "value": "boiler",
              "next": "duration_ref"
            },
            {
              "label": "Neuinstallation / Umbau (Bad, Küche)",
              "value": "neuinstallation",
              "next": "sanitaer_wo"
            }
          ]
        },
        "sanitaer_leck_staerke": {
          "id": "sanitaer_leck_staerke",
          "type": "single_select",
          "question": "Wie stark läuft das Wasser aus?",
          "options": [
            {
              "label": "Tropft langsam",
              "value": "tropft",
              "next": "sanitaer_wo"
            },
            {
              "label": "Läuft kontinuierlich",
              "value": "laeuft",
              "next": "sanitaer_wo"
            },
            {
              "label": "Strömt heraus / akuter Wasserschaden",
              "value": "stroemt",
              "next": "sanitaer_haupthahn"
            }
          ]
        },
        "sanitaer_haupthahn": {
          "id": "sanitaer_haupthahn",
          "type": "info_step",
          "title": "Wichtig: Haupthahn zudrehen!",
          "content": "Bei einem akuten Wasserschaden bitte sofort den Haupthahn zudrehen, falls noch nicht geschehen. Wir vermitteln Ihnen sofort einen Notdienst.",
          "ctaLabel": "Verstanden, weiter",
          "next": "sanitaer_wo"
        },
        "sanitaer_wo": {
          "id": "sanitaer_wo",
          "type": "single_select",
          "question": "Wo ist das Problem?",
          "options": [
            {
              "label": "Küche",
              "value": "kueche",
              "next": "duration_ref"
            },
            {
              "label": "Badezimmer",
              "value": "bad",
              "next": "duration_ref"
            },
            {
              "label": "Gäste-WC",
              "value": "wc",
              "next": "duration_ref"
            },
            {
              "label": "Keller / Hauswirtschaftsraum",
              "value": "keller",
              "next": "duration_ref"
            },
            {
              "label": "Außen / Garten",
              "value": "aussen",
              "next": "duration_ref"
            },
            {
              "label": "Mehrere Räume",
              "value": "mehrfach",
              "next": "duration_ref"
            }
          ]
        },
        "duration_ref": {
          "id": "duration",
          "type": "single_select",
          "question": "Seit wann besteht das Problem?",
          "next": "urgency_ref",
          "options": [
            {
              "label": "Gerade eben aufgetreten",
              "value": "gerade"
            },
            {
              "label": "Heute",
              "value": "heute"
            },
            {
              "label": "Seit ein paar Tagen",
              "value": "tage"
            },
            {
              "label": "Seit über einer Woche",
              "value": "woche_plus"
            },
            {
              "label": "Schon länger / kommt immer wieder",
              "value": "wiederkehrend"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "maler": {
      "id": "maler",
      "name": "Maler",
      "icon": "palette",
      "rootNodeId": "maler_was",
      "nodes": {
        "maler_was": {
          "id": "maler_was",
          "type": "single_select",
          "question": "Was soll gemacht werden?",
          "options": [
            {
              "label": "Wände streichen",
              "value": "waende",
              "next": "maler_umfang"
            },
            {
              "label": "Decke streichen",
              "value": "decke",
              "next": "maler_umfang"
            },
            {
              "label": "Tapezieren",
              "value": "tapezieren",
              "next": "maler_umfang"
            },
            {
              "label": "Tapeten entfernen",
              "value": "tapete_entfernen",
              "next": "maler_umfang"
            },
            {
              "label": "Lackieren (Türen, Fenster, Heizkörper)",
              "value": "lackieren",
              "next": "maler_umfang"
            },
            {
              "label": "Außenfassade",
              "value": "fassade",
              "next": "maler_umfang"
            },
            {
              "label": "Spachteln / Risse reparieren",
              "value": "spachteln",
              "next": "maler_umfang"
            }
          ]
        },
        "maler_umfang": {
          "id": "maler_umfang",
          "type": "single_select",
          "question": "Wie viel soll gemacht werden?",
          "options": [
            {
              "label": "Ein Raum",
              "value": "1_raum",
              "next": "maler_flaeche"
            },
            {
              "label": "2-3 Räume",
              "value": "2_3_raeume",
              "next": "maler_flaeche"
            },
            {
              "label": "Komplette Wohnung",
              "value": "wohnung",
              "next": "maler_flaeche"
            },
            {
              "label": "Komplettes Haus",
              "value": "haus",
              "next": "maler_flaeche"
            },
            {
              "label": "Nur eine Teilfläche",
              "value": "teilflaeche",
              "next": "maler_flaeche"
            }
          ]
        },
        "maler_flaeche": {
          "id": "maler_flaeche",
          "type": "single_select",
          "question": "Wie groß ist die Fläche ungefähr?",
          "helpText": "Eine Schätzung reicht völlig.",
          "options": [
            {
              "label": "Klein (bis 20 m²)",
              "value": "bis_20",
              "next": "maler_zustand"
            },
            {
              "label": "Mittel (20-50 m²)",
              "value": "20_50",
              "next": "maler_zustand"
            },
            {
              "label": "Groß (50-100 m²)",
              "value": "50_100",
              "next": "maler_zustand"
            },
            {
              "label": "Sehr groß (über 100 m²)",
              "value": "ueber_100",
              "next": "maler_zustand"
            },
            {
              "label": "Weiß ich nicht genau",
              "value": "unbekannt",
              "next": "maler_zustand"
            }
          ]
        },
        "maler_zustand": {
          "id": "maler_zustand",
          "type": "single_select",
          "question": "Wie ist der Zustand der Fläche?",
          "options": [
            {
              "label": "Gut – kann direkt gestrichen werden",
              "value": "gut",
              "next": "urgency_ref"
            },
            {
              "label": "Kleine Risse oder Löcher",
              "value": "kleine_schaeden",
              "next": "urgency_ref"
            },
            {
              "label": "Größere Vorbereitung nötig (Schimmel, Putz)",
              "value": "vorbereitung",
              "next": "urgency_ref"
            },
            {
              "label": "Unsicher – bitte schauen lassen",
              "value": "unsicher",
              "next": "urgency_ref"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "tischler": {
      "id": "tischler",
      "name": "Tischler",
      "icon": "box",
      "rootNodeId": "tischler_was",
      "nodes": {
        "tischler_was": {
          "id": "tischler_was",
          "type": "single_select",
          "question": "Was benötigen Sie?",
          "options": [
            {
              "label": "Möbel anfertigen (Maßanfertigung)",
              "value": "anfertigung",
              "next": "tischler_anfertigung_typ"
            },
            {
              "label": "Möbel reparieren",
              "value": "reparatur",
              "next": "tischler_objekt"
            },
            {
              "label": "Möbel aufbauen (Ikea o.ä.)",
              "value": "aufbau",
              "next": "tischler_objekt"
            },
            {
              "label": "Tür reparieren / einbauen",
              "value": "tuer",
              "next": "duration_ref"
            },
            {
              "label": "Fenster reparieren (Holz)",
              "value": "fenster",
              "next": "duration_ref"
            },
            {
              "label": "Einbauschrank / begehbarer Kleiderschrank",
              "value": "einbauschrank",
              "next": "tischler_raum"
            },
            {
              "label": "Holzboden / Parkett (Reparatur)",
              "value": "holzboden",
              "next": "duration_ref"
            },
            {
              "label": "Treppe (Reparatur, Neubau)",
              "value": "treppe",
              "next": "duration_ref"
            }
          ]
        },
        "tischler_anfertigung_typ": {
          "id": "tischler_anfertigung_typ",
          "type": "single_select",
          "question": "Was soll angefertigt werden?",
          "options": [
            {
              "label": "Schrank / Regal",
              "value": "schrank",
              "next": "tischler_raum"
            },
            {
              "label": "Tisch",
              "value": "tisch",
              "next": "tischler_raum"
            },
            {
              "label": "Küche / Küchenelement",
              "value": "kueche",
              "next": "tischler_raum"
            },
            {
              "label": "Etwas anderes",
              "value": "sonstiges",
              "next": "tischler_raum"
            }
          ]
        },
        "tischler_objekt": {
          "id": "tischler_objekt",
          "type": "single_select",
          "question": "Um welches Möbelstück geht es?",
          "options": [
            {
              "label": "Schrank",
              "value": "schrank",
              "next": "duration_ref"
            },
            {
              "label": "Tisch / Stuhl",
              "value": "tisch_stuhl",
              "next": "duration_ref"
            },
            {
              "label": "Bett",
              "value": "bett",
              "next": "duration_ref"
            },
            {
              "label": "Sofa / Polstermöbel",
              "value": "polster",
              "next": "duration_ref"
            },
            {
              "label": "Küchenmöbel",
              "value": "kueche",
              "next": "duration_ref"
            },
            {
              "label": "Etwas anderes",
              "value": "sonstiges",
              "next": "duration_ref"
            }
          ]
        },
        "tischler_raum": {
          "id": "tischler_raum",
          "type": "single_select",
          "question": "In welchem Raum?",
          "options": [
            {
              "label": "Wohnzimmer",
              "value": "wohnzimmer",
              "next": "urgency_ref"
            },
            {
              "label": "Schlafzimmer",
              "value": "schlafzimmer",
              "next": "urgency_ref"
            },
            {
              "label": "Küche",
              "value": "kueche",
              "next": "urgency_ref"
            },
            {
              "label": "Bad",
              "value": "bad",
              "next": "urgency_ref"
            },
            {
              "label": "Flur / Diele",
              "value": "flur",
              "next": "urgency_ref"
            },
            {
              "label": "Büro / Arbeitszimmer",
              "value": "buero",
              "next": "urgency_ref"
            },
            {
              "label": "Anderer Raum",
              "value": "sonstiges",
              "next": "urgency_ref"
            }
          ]
        },
        "duration_ref": {
          "id": "duration",
          "type": "single_select",
          "question": "Seit wann besteht das Problem?",
          "next": "urgency_ref",
          "options": [
            {
              "label": "Gerade eben aufgetreten",
              "value": "gerade"
            },
            {
              "label": "Heute",
              "value": "heute"
            },
            {
              "label": "Seit ein paar Tagen",
              "value": "tage"
            },
            {
              "label": "Seit über einer Woche",
              "value": "woche_plus"
            },
            {
              "label": "Schon länger / kommt immer wieder",
              "value": "wiederkehrend"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "bodenleger": {
      "id": "bodenleger",
      "name": "Bodenleger",
      "icon": "grid",
      "rootNodeId": "bodenleger_was",
      "nodes": {
        "bodenleger_was": {
          "id": "bodenleger_was",
          "type": "single_select",
          "question": "Was soll passieren?",
          "options": [
            {
              "label": "Neuen Boden verlegen",
              "value": "neuverlegung",
              "next": "bodenleger_belag_neu"
            },
            {
              "label": "Bestehenden Boden reparieren",
              "value": "reparatur",
              "next": "bodenleger_belag_bestand"
            },
            {
              "label": "Alten Boden entfernen",
              "value": "entfernung",
              "next": "bodenleger_belag_bestand"
            },
            {
              "label": "Aufarbeiten / Schleifen (Parkett, Dielen)",
              "value": "aufarbeitung",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Beratung – ich bin unsicher",
              "value": "beratung",
              "next": "bodenleger_flaeche"
            }
          ]
        },
        "bodenleger_belag_neu": {
          "id": "bodenleger_belag_neu",
          "type": "single_select",
          "question": "Welcher Bodenbelag soll verlegt werden?",
          "options": [
            {
              "label": "Parkett",
              "value": "parkett",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Laminat",
              "value": "laminat",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Vinyl / Designboden",
              "value": "vinyl",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Fliesen",
              "value": "fliesen",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Teppich",
              "value": "teppich",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Noch unentschieden",
              "value": "unentschieden",
              "next": "bodenleger_flaeche"
            }
          ]
        },
        "bodenleger_belag_bestand": {
          "id": "bodenleger_belag_bestand",
          "type": "single_select",
          "question": "Welcher Boden ist aktuell verlegt?",
          "options": [
            {
              "label": "Parkett",
              "value": "parkett",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Laminat",
              "value": "laminat",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Vinyl / PVC",
              "value": "vinyl",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Fliesen",
              "value": "fliesen",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Teppich",
              "value": "teppich",
              "next": "bodenleger_flaeche"
            },
            {
              "label": "Weiß ich nicht",
              "value": "unbekannt",
              "next": "bodenleger_flaeche"
            }
          ]
        },
        "bodenleger_flaeche": {
          "id": "bodenleger_flaeche",
          "type": "single_select",
          "question": "Wie groß ist die Fläche?",
          "options": [
            {
              "label": "Bis 20 m² (1 Raum)",
              "value": "bis_20",
              "next": "urgency_ref"
            },
            {
              "label": "20-50 m²",
              "value": "20_50",
              "next": "urgency_ref"
            },
            {
              "label": "50-100 m²",
              "value": "50_100",
              "next": "urgency_ref"
            },
            {
              "label": "Mehr als 100 m²",
              "value": "ueber_100",
              "next": "urgency_ref"
            },
            {
              "label": "Weiß ich nicht",
              "value": "unbekannt",
              "next": "urgency_ref"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "gartenbau": {
      "id": "gartenbau",
      "name": "Gartenbau",
      "icon": "leaf",
      "rootNodeId": "gartenbau_was",
      "nodes": {
        "gartenbau_was": {
          "id": "gartenbau_was",
          "type": "single_select",
          "question": "Was soll gemacht werden?",
          "options": [
            {
              "label": "Rasen pflegen / mähen",
              "value": "rasen",
              "next": "gartenbau_groesse"
            },
            {
              "label": "Hecke / Strauch schneiden",
              "value": "hecke",
              "next": "gartenbau_groesse"
            },
            {
              "label": "Baum fällen / schneiden",
              "value": "baum",
              "next": "gartenbau_baum_groesse"
            },
            {
              "label": "Garten neu anlegen / umgestalten",
              "value": "neuanlage",
              "next": "gartenbau_groesse"
            },
            {
              "label": "Pflasterarbeiten / Wege",
              "value": "pflaster",
              "next": "gartenbau_groesse"
            },
            {
              "label": "Bewässerung installieren",
              "value": "bewaesserung",
              "next": "gartenbau_groesse"
            },
            {
              "label": "Aufräumen / Grünschnitt entsorgen",
              "value": "aufraeumen",
              "next": "gartenbau_groesse"
            },
            {
              "label": "Winterdienst",
              "value": "winterdienst",
              "next": "gartenbau_haeufigkeit"
            }
          ]
        },
        "gartenbau_baum_groesse": {
          "id": "gartenbau_baum_groesse",
          "type": "single_select",
          "question": "Wie groß ist der Baum?",
          "options": [
            {
              "label": "Klein (bis 3 m)",
              "value": "klein",
              "next": "urgency_ref"
            },
            {
              "label": "Mittel (3-8 m)",
              "value": "mittel",
              "next": "urgency_ref"
            },
            {
              "label": "Groß (über 8 m)",
              "value": "gross",
              "next": "urgency_ref"
            },
            {
              "label": "Mehrere Bäume",
              "value": "mehrere",
              "next": "urgency_ref"
            }
          ]
        },
        "gartenbau_groesse": {
          "id": "gartenbau_groesse",
          "type": "single_select",
          "question": "Wie groß ist die Fläche?",
          "options": [
            {
              "label": "Klein (bis 50 m²)",
              "value": "klein",
              "next": "gartenbau_haeufigkeit"
            },
            {
              "label": "Mittel (50-200 m²)",
              "value": "mittel",
              "next": "gartenbau_haeufigkeit"
            },
            {
              "label": "Groß (200-500 m²)",
              "value": "gross",
              "next": "gartenbau_haeufigkeit"
            },
            {
              "label": "Sehr groß (über 500 m²)",
              "value": "sehr_gross",
              "next": "gartenbau_haeufigkeit"
            },
            {
              "label": "Weiß ich nicht",
              "value": "unbekannt",
              "next": "gartenbau_haeufigkeit"
            }
          ]
        },
        "gartenbau_haeufigkeit": {
          "id": "gartenbau_haeufigkeit",
          "type": "single_select",
          "question": "Wie oft soll das passieren?",
          "options": [
            {
              "label": "Einmalig",
              "value": "einmalig",
              "next": "urgency_ref"
            },
            {
              "label": "Regelmäßig (wöchentlich/monatlich)",
              "value": "regelmaessig",
              "next": "urgency_ref"
            },
            {
              "label": "Saisonal (Frühjahr/Herbst)",
              "value": "saisonal",
              "next": "urgency_ref"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "schluesseldienst": {
      "id": "schluesseldienst",
      "name": "Schlüsseldienst",
      "icon": "lock",
      "rootNodeId": "schluessel_situation",
      "nodes": {
        "schluessel_situation": {
          "id": "schluessel_situation",
          "type": "single_select",
          "question": "Was ist passiert?",
          "options": [
            {
              "label": "Ich bin ausgesperrt – Notfall",
              "value": "ausgesperrt",
              "next": "schluessel_wo"
            },
            {
              "label": "Schlüssel ist abgebrochen / steckt",
              "value": "abgebrochen",
              "next": "schluessel_wo"
            },
            {
              "label": "Schloss ist defekt / klemmt",
              "value": "schloss_defekt",
              "next": "schluessel_wo"
            },
            {
              "label": "Ich möchte das Schloss austauschen",
              "value": "austausch",
              "next": "schluessel_wo"
            },
            {
              "label": "Sicherheitsupgrade (z.B. nach Einbruch)",
              "value": "sicherheit",
              "next": "schluessel_wo"
            },
            {
              "label": "Neü Schließanlage",
              "value": "neue_anlage",
              "next": "schluessel_wo"
            }
          ]
        },
        "schluessel_wo": {
          "id": "schluessel_wo",
          "type": "single_select",
          "question": "Um welche Tür geht es?",
          "options": [
            {
              "label": "Wohnungstür",
              "value": "wohnungstuer",
              "next": "schluessel_typ"
            },
            {
              "label": "Haustür / Hauseingang",
              "value": "haustuer",
              "next": "schluessel_typ"
            },
            {
              "label": "Hintertür / Nebeneingang",
              "value": "hintertuer",
              "next": "schluessel_typ"
            },
            {
              "label": "Auto",
              "value": "auto",
              "next": "urgency_ref"
            },
            {
              "label": "Tresor / Safe",
              "value": "tresor",
              "next": "urgency_ref"
            },
            {
              "label": "Briefkasten / Garage",
              "value": "sonstiges",
              "next": "urgency_ref"
            }
          ]
        },
        "schluessel_typ": {
          "id": "schluessel_typ",
          "type": "single_select",
          "question": "Wissen Sie, was für ein Schloss verbaut ist?",
          "helpText": "Falls nicht – kein Problem, einfach übergehen.",
          "options": [
            {
              "label": "Standard-Profilzylinder",
              "value": "standard",
              "next": "urgency_ref"
            },
            {
              "label": "Sicherheitsschloss / Mehrfachverriegelung",
              "value": "sicherheit",
              "next": "urgency_ref"
            },
            {
              "label": "Elektronisches / Smart Lock",
              "value": "elektronisch",
              "next": "urgency_ref"
            },
            {
              "label": "Weiß ich nicht",
              "value": "unbekannt",
              "next": "urgency_ref"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "reinigung": {
      "id": "reinigung",
      "name": "Reinigung",
      "icon": "sparkles",
      "rootNodeId": "reinigung_art",
      "nodes": {
        "reinigung_art": {
          "id": "reinigung_art",
          "type": "single_select",
          "question": "Welche Art von Reinigung?",
          "options": [
            {
              "label": "Grundreinigung Wohnung/Haus",
              "value": "grundreinigung",
              "next": "reinigung_objekt"
            },
            {
              "label": "Regelmäßige Haushaltsreinigung",
              "value": "regelmaessig",
              "next": "reinigung_objekt"
            },
            {
              "label": "Endreinigung (Aus- oder Einzug)",
              "value": "endreinigung",
              "next": "reinigung_objekt"
            },
            {
              "label": "Fensterreinigung",
              "value": "fenster",
              "next": "reinigung_objekt"
            },
            {
              "label": "Teppich- / Polsterreinigung",
              "value": "teppich",
              "next": "reinigung_objekt"
            },
            {
              "label": "Büroreinigung",
              "value": "buero",
              "next": "reinigung_buero_typ"
            },
            {
              "label": "Bauschluss-Reinigung",
              "value": "bau",
              "next": "reinigung_groesse"
            },
            {
              "label": "Sonderreinigung (z.B. nach Wasserschaden)",
              "value": "sonder",
              "next": "reinigung_objekt"
            }
          ]
        },
        "reinigung_objekt": {
          "id": "reinigung_objekt",
          "type": "single_select",
          "question": "Was soll gereinigt werden?",
          "options": [
            {
              "label": "Wohnung",
              "value": "wohnung",
              "next": "reinigung_groesse"
            },
            {
              "label": "Haus",
              "value": "haus",
              "next": "reinigung_groesse"
            },
            {
              "label": "Praxis / Kanzlei",
              "value": "praxis",
              "next": "reinigung_groesse"
            },
            {
              "label": "Ferienwohnung / Airbnb",
              "value": "ferienwohnung",
              "next": "reinigung_groesse"
            },
            {
              "label": "Etwas anderes",
              "value": "sonstiges",
              "next": "reinigung_groesse"
            }
          ]
        },
        "reinigung_buero_typ": {
          "id": "reinigung_buero_typ",
          "type": "single_select",
          "question": "Was für ein Büro?",
          "options": [
            {
              "label": "Einzelbüro / kleines Team (bis 50 m²)",
              "value": "klein",
              "next": "reinigung_haeufigkeit"
            },
            {
              "label": "Mittleres Büro (50-200 m²)",
              "value": "mittel",
              "next": "reinigung_haeufigkeit"
            },
            {
              "label": "Großes Büro (über 200 m²)",
              "value": "gross",
              "next": "reinigung_haeufigkeit"
            }
          ]
        },
        "reinigung_groesse": {
          "id": "reinigung_groesse",
          "type": "single_select",
          "question": "Wie groß ist die Fläche?",
          "options": [
            {
              "label": "Klein (bis 50 m² / 1-2 Zimmer)",
              "value": "klein",
              "next": "reinigung_haeufigkeit"
            },
            {
              "label": "Mittel (50-100 m² / 3-4 Zimmer)",
              "value": "mittel",
              "next": "reinigung_haeufigkeit"
            },
            {
              "label": "Groß (100-200 m²)",
              "value": "gross",
              "next": "reinigung_haeufigkeit"
            },
            {
              "label": "Sehr groß (über 200 m²)",
              "value": "sehr_gross",
              "next": "reinigung_haeufigkeit"
            }
          ]
        },
        "reinigung_haeufigkeit": {
          "id": "reinigung_haeufigkeit",
          "type": "single_select",
          "question": "Wie oft?",
          "options": [
            {
              "label": "Einmalig",
              "value": "einmalig",
              "next": "urgency_ref"
            },
            {
              "label": "Wöchentlich",
              "value": "woechentlich",
              "next": "urgency_ref"
            },
            {
              "label": "Alle 2 Wochen",
              "value": "zweiwoechentlich",
              "next": "urgency_ref"
            },
            {
              "label": "Monatlich",
              "value": "monatlich",
              "next": "urgency_ref"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "dachdecker": {
      "id": "dachdecker",
      "name": "Dachdecker",
      "icon": "home",
      "rootNodeId": "dachdecker_problem",
      "nodes": {
        "dachdecker_problem": {
          "id": "dachdecker_problem",
          "type": "single_select",
          "question": "Was ist das Problem am Dach?",
          "options": [
            {
              "label": "Dach undicht / Wassereintritt",
              "value": "undicht",
              "next": "dachdecker_dachart"
            },
            {
              "label": "Sturm- oder Wetterschaden",
              "value": "sturmschaden",
              "next": "dachdecker_dachart"
            },
            {
              "label": "Dachsanierung / Neueindeckung",
              "value": "neueindeckung",
              "next": "dachdecker_dachart"
            },
            {
              "label": "Dachfenster einbauen oder tauschen",
              "value": "dachfenster",
              "next": "urgency_ref"
            },
            {
              "label": "Dachrinne / Fallrohr",
              "value": "dachrinne",
              "next": "urgency_ref"
            },
            {
              "label": "Kaminabdeckung / Schornsteinkopf-Sanierung",
              "value": "schornstein",
              "next": "urgency_ref"
            },
            {
              "label": "Wartung / Inspektion",
              "value": "wartung",
              "next": "urgency_ref"
            },
            {
              "label": "Etwas anderes",
              "value": "sonstiges",
              "next": "dachdecker_dachart"
            }
          ]
        },
        "dachdecker_dachart": {
          "id": "dachdecker_dachart",
          "type": "single_select",
          "question": "Was für ein Dach ist betroffen?",
          "options": [
            {
              "label": "Steildach mit Ziegeln (Ton oder Beton)",
              "value": "steildach",
              "next": "dachdecker_groesse"
            },
            {
              "label": "Flachdach",
              "value": "flachdach",
              "next": "dachdecker_groesse"
            },
            {
              "label": "Bitumen (Schweißbahn, Bitumendachschindeln) oder Foliendach",
              "value": "bitumen",
              "next": "dachdecker_groesse"
            },
            {
              "label": "Metalldach (Zink, Kupfer, Aluminium, Stahl)",
              "value": "metalldach",
              "next": "dachdecker_groesse"
            },
            {
              "label": "Reet- oder Schieferdach",
              "value": "reet_schiefer",
              "next": "dachdecker_groesse"
            },
            {
              "label": "Weiß ich nicht",
              "value": "unbekannt",
              "next": "dachdecker_groesse"
            }
          ]
        },
        "dachdecker_groesse": {
          "id": "dachdecker_groesse",
          "type": "single_select",
          "question": "Wie groß ist die betroffene Fläche?",
          "options": [
            {
              "label": "Kleine Stelle (bis 1 m²)",
              "value": "punktuell",
              "next": "urgency_ref"
            },
            {
              "label": "Bis ca. 5 m²",
              "value": "klein",
              "next": "urgency_ref"
            },
            {
              "label": "5 bis 20 m²",
              "value": "mittel",
              "next": "urgency_ref"
            },
            {
              "label": "Größere Fläche / komplettes Dach",
              "value": "gross",
              "next": "urgency_ref"
            },
            {
              "label": "Weiß ich nicht",
              "value": "unbekannt",
              "next": "urgency_ref"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    },
    "transport_umzug": {
      "id": "transport_umzug",
      "name": "Transport & Umzug",
      "icon": "truck",
      "rootNodeId": "transport_art",
      "nodes": {
        "transport_art": {
          "id": "transport_art",
          "type": "single_select",
          "question": "Was soll transportiert werden?",
          "options": [
            {
              "label": "Kompletter Wohnungsumzug",
              "value": "wohnung_umzug",
              "next": "transport_groesse"
            },
            {
              "label": "Hausumzug",
              "value": "haus_umzug",
              "next": "transport_groesse"
            },
            {
              "label": "Einzelne Möbel oder Sperrgut",
              "value": "einzelne_moebel",
              "next": "transport_anzahl"
            },
            {
              "label": "Klavier / Tresor / schwere Stücke",
              "value": "schwerstgut",
              "next": "transport_etage"
            },
            {
              "label": "Büro- oder Geschäftsumzug",
              "value": "buero_umzug",
              "next": "transport_groesse"
            },
            {
              "label": "Entrümpelung / Haushaltsauflösung",
              "value": "entruempelung",
              "next": "transport_groesse"
            },
            {
              "label": "Etwas anderes",
              "value": "sonstiges",
              "next": "transport_anzahl"
            }
          ]
        },
        "transport_groesse": {
          "id": "transport_groesse",
          "type": "single_select",
          "question": "Wie groß ist das Objekt?",
          "options": [
            {
              "label": "1-Zimmer / WG-Zimmer",
              "value": "ein_zimmer",
              "next": "transport_etage"
            },
            {
              "label": "2-Zimmer-Wohnung",
              "value": "zwei_zimmer",
              "next": "transport_etage"
            },
            {
              "label": "3 bis 4 Zimmer",
              "value": "drei_vier_zimmer",
              "next": "transport_etage"
            },
            {
              "label": "Haus / 5+ Zimmer",
              "value": "haus_gross",
              "next": "transport_etage"
            }
          ]
        },
        "transport_anzahl": {
          "id": "transport_anzahl",
          "type": "single_select",
          "question": "Wie viele Stücke ungefähr?",
          "options": [
            {
              "label": "1 bis 3 Stücke",
              "value": "wenige",
              "next": "transport_etage"
            },
            {
              "label": "4 bis 10 Stücke",
              "value": "mittel",
              "next": "transport_etage"
            },
            {
              "label": "Mehr als 10",
              "value": "viele",
              "next": "transport_etage"
            }
          ]
        },
        "transport_etage": {
          "id": "transport_etage",
          "type": "single_select",
          "question": "Etage und Aufzug?",
          "options": [
            {
              "label": "Erdgeschoss",
              "value": "eg",
              "next": "transport_distanz"
            },
            {
              "label": "1. - 3. Stock mit Aufzug",
              "value": "mit_aufzug",
              "next": "transport_distanz"
            },
            {
              "label": "1. - 3. Stock ohne Aufzug",
              "value": "ohne_aufzug_niedrig",
              "next": "transport_distanz"
            },
            {
              "label": "Höher ohne Aufzug",
              "value": "ohne_aufzug_hoch",
              "next": "transport_distanz"
            }
          ]
        },
        "transport_distanz": {
          "id": "transport_distanz",
          "type": "single_select",
          "question": "Wie weit ist der Transport?",
          "options": [
            {
              "label": "Innerhalb der Stadt",
              "value": "stadt",
              "next": "urgency_ref"
            },
            {
              "label": "Innerhalb des Bundeslands",
              "value": "bundesland",
              "next": "urgency_ref"
            },
            {
              "label": "Bundesweit",
              "value": "bundesweit",
              "next": "urgency_ref"
            },
            {
              "label": "Ins Ausland",
              "value": "ausland",
              "next": "urgency_ref"
            }
          ]
        },
        "urgency_ref": {
          "id": "urgency",
          "type": "single_select",
          "question": "Wie dringend ist es?",
          "next": "end_step",
          "options": [
            {
              "label": "Notfall – sofort",
              "value": "notfall",
              "icon": "alert"
            },
            {
              "label": "Heute noch",
              "value": "heute",
              "icon": "clock"
            },
            {
              "label": "Diese Woche",
              "value": "diese_woche",
              "icon": "calendar"
            },
            {
              "label": "Flexibel / geplant",
              "value": "flexibel",
              "icon": "calendar-check"
            }
          ]
        },
        "end_step": {
          "id": "end_step",
          "type": "summary_and_extras",
          "title": "Fast geschafft!",
          "ctaLabel": "Auftrag absenden",
          "components": [
            {
              "type": "summary_preview",
              "label": "Ihr Auftrag im Überblick"
            },
            {
              "type": "photo_upload",
              "label": "Foto hinzufügen (optional)",
              "helpText": "Ein Bild hilft dem Handwerker, das Problem besser einzuschätzen.",
              "maxFiles": 5,
              "required": false
            },
            {
              "type": "free_text",
              "id": "notes",
              "label": "Weitere Hinweise (optional)",
              "placeholder": "z.B. Hund im Haus, Klingel kaputt, Stockwerk ohne Aufzug ...",
              "maxLength": 500,
              "required": false
            },
            {
              "type": "address_confirm",
              "label": "Adresse bestätigen",
              "required": true
            }
          ]
        }
      }
    }
  }
};
